import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Chip from './Chip';

// Matches the in-app Key Moments card: colored left bar by type, description
// in body, "Why it matters: …" inline below, type + timestamp chips at the
// bottom. Background is a light gray (matching the web's #f5f7fa) — the rail
// + tint do the work, no hairline outer border.
const TYPE_PALETTE = {
  Commitment:  { bar: colors.success, chip: 'success' },
  Decision:    { bar: colors.success, chip: 'success' },
  Opportunity: { bar: colors.teal,    chip: 'default' },
  Concern:     { bar: colors.warning, chip: 'warning' },
  Objection:   { bar: colors.danger,  chip: 'danger'  },
};

const MomentRow = ({ moment, isLast }) => {
  const palette = TYPE_PALETTE[moment.type] || TYPE_PALETTE.Opportunity;
  return (
    <View wrap={false} style={{
      flexDirection: 'row',
      backgroundColor: '#f5f7fa',
      borderRadius: 4,
      overflow: 'hidden',
      marginBottom: isLast ? 0 : space.sm,
    }}>
      <View style={{ width: 3, backgroundColor: palette.bar }} />
      <View style={{ flex: 1, paddingVertical: 10, paddingHorizontal: space.md }}>
        <Text style={[type.bodyMed, { color: colors.ink }]}>{moment.description}</Text>
        {moment.whyItMatters && (
          <Text style={[type.body, { color: colors.inkSoft, marginTop: 4 }]}>
            <Text style={{ fontWeight: 600, color: colors.ink }}>Why it matters: </Text>
            {moment.whyItMatters}
          </Text>
        )}
        {(moment.type || moment.timestamp) && (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
            {moment.type && <Chip variant={palette.chip}>{moment.type}</Chip>}
            {moment.timestamp && <Chip variant="neutral">{moment.timestamp}</Chip>}
          </View>
        )}
      </View>
    </View>
  );
};

export default MomentRow;
